import React from 'react';
import {EfaLogo} from '../../assets/Logos/EfaLogo';
import './Header.scss';
import {Link} from 'react-router-dom';
import MainMenu from '../MainMenu/MainMenu';
import GridLegacy from '@mui/material/GridLegacy';
import {useAuthContext} from '../../services/AuthContext';
import {environmentService} from '../../infrastructure/EnvironmentService';

const Header = () => {

  const authContext = useAuthContext();
  const environment = environmentService.getEnvironment();

  return (
    <div className='header'>
      <GridLegacy
        container
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        spacing={1}
      >
        <GridLegacy item xs={2}>
          <Link to='/'>
            <EfaLogo environment={environment}/>
          </Link>
        </GridLegacy>
        {authContext.userAuthenticated && (
          <>
            <GridLegacy item xs={8}>
              <MainMenu data-testid='header--menu'/>
            </GridLegacy>
          </>
        )}
      </GridLegacy>
    </div>
  );
};

export default Header;
